export const RULE_CHANNELS = [
    { key: 'email', label: 'Correo' },
    { key: 'push', label: 'Aviso push' },
] as const;

export const RULE_SENDER_OPTIONS = [
    {
        key: 'alberto',
        label: 'Alberto M. · alberto@news.aipeces.com (responde a hola@aipeces.com)',
    },
] as const;

export const RULE_ANCHORS = [
    { key: 'signup', label: 'el registro' },
    { key: 'last_seen', label: 'la última entrada' },
    { key: 'last_capture', label: 'la última captura' },
    { key: 'trial_started', label: 'empezó la prueba Pro' },
    { key: 'trial_ended', label: 'terminó la prueba Pro' },
    { key: 'paid_started', label: 'compró Pro' },
    { key: 'subscription_canceled', label: 'canceló Pro (o pidió baja al periodo)' },
    { key: 'renewal_due', label: 'la renovación de Pro' },
    { key: 'month_start', label: 'el día N de cada mes (informe del mes anterior)' },
    { key: 'chapter_10_completed', label: 'completó los 10 capítulos' },
] as const;

/** Bloques de datos HTML insertables en el cuerpo ({bloque:…}). */
export const EMAIL_DATA_BLOCKS = [
    { token: '{bloque:cifras_mes}', help: 'Capturas, especies y días del mes anterior (+ delta).' },
    { token: '{bloque:mis_especies}', help: 'Top especies del mes. Añade periodo=total para histórico.' },
    { token: '{bloque:horas_mes}', help: 'Franjas 4 h del mes anterior (como Patrones).' },
    { token: '{bloque:horas}', help: 'Franjas horarias de todas sus capturas.' },
    { token: '{bloque:meses}', help: 'Distribución por meses del año.' },
    { token: '{bloque:hallazgos}', help: 'Mejor franja, mes y especie (valores reales).' },
    { token: '{bloque:hallazgos_tapados}', help: 'Mismo esqueleto tapado («Con Pro»).' },
    { token: '{bloque:progreso_analisis}', help: 'Barra hasta el umbral real (8 en celda ~11 km). Alias: progreso_10.' },
    { token: '{bloque:mi_zona}', help: 'Comunidad a 50 km (actividad alta/media/baja, sin cifras). Opcional: dias=14.' },
    { token: '{bloque:proximo_buen_dia}', help: 'Buen día (+2/+3); tapado si no es Pro/trial.' },
    { token: '{bloque:mejor_captura}', help: 'Captura pública del mes con más likes.' },
    { token: '{bloque:pendientes}', help: 'Tesoros sin abrir y/o saldo (si hay).' },
    { token: '{bloque:saldo_cartera}', help: 'Solo cartera («Tienes Y €…»); se omite si es 0.' },
    { token: '{bloque:uso_prueba}', help: 'Uso durante la prueba (eventos existentes).' },
] as const;

export const RULE_TOPICS = [
    { key: 'diario', label: 'Diario' },
    { key: 'recompensas', label: 'Recompensas' },
    { key: 'pro_activacion', label: 'Prueba Pro' },
    { key: 'pro_analisis', label: 'Análisis Pro' },
    { key: 'tienda', label: 'Tienda y monedero' },
    { key: 'planificacion', label: 'Planificación' },
    { key: 'clubes', label: 'Clubes' },
    { key: 'embajador', label: 'Embajador' },
    { key: 'cuenta', label: 'Cuenta' },
    { key: 'pro', label: 'Pro' },
    { key: 'zona', label: 'Zona' },
    { key: 'social', label: 'Social' },
    { key: 'logros', label: 'Logros' },
    { key: 'academia', label: 'Academia' },
] as const;

export const RULE_SUCCESS = [
    { key: '', label: 'Sin objetivo' },
    { key: 'app_return', label: 'Volvió a la app' },
    { key: 'capture', label: 'Subió una captura' },
    { key: 'became_pro', label: 'Se hizo Pro' },
    { key: 'joined_club', label: 'Entró en un club' },
    { key: 'shop_purchase', label: 'Compró en la tienda' },
    { key: 'plan_created', label: 'Creó una planificación' },
    { key: 'referral_sent', label: 'Un amigo se unió con su invitación' },
    { key: 'trial_started', label: 'Empezó la prueba Pro' },
    { key: 'rewards_viewed', label: 'Vio Recompensas / Tesoros' },
    { key: 'diary_viewed', label: 'Vio su Diario de capturas' },
    { key: 'stats_viewed', label: 'Vio Estadísticas' },
    { key: 'shop_click', label: 'Clic en la Tienda' },
    { key: 'pro_feature_used', label: 'Usó una función Pro' },
    { key: 'club_interest', label: 'Mostró interés en un club' },
] as const;

export const RULE_CONDITION_SIGNALS = [
    { key: 'has_capture', label: 'Tiene al menos una captura', kind: 'bool' },
    { key: 'has_zone', label: 'Tiene zona', kind: 'bool' },
    { key: 'is_pro', label: 'Es Pro', kind: 'bool' },
    { key: 'paid_pro', label: 'Pro de pago', kind: 'bool' },
    { key: 'had_trial', label: 'Ya tuvo la prueba Pro', kind: 'bool' },
    { key: 'analysis_ready', label: 'Análisis listo (8+ capturas en la celda ~11 km)', kind: 'bool' },
    { key: 'in_club', label: 'Está en un club', kind: 'bool' },
    { key: 'in_trial', label: 'Prueba Pro activa', kind: 'bool' },
    { key: 'in_real_club', label: 'Está en un club no oficial', kind: 'bool' },
    { key: 'is_annual_plan', label: 'Pro anual activo (year/annual)', kind: 'bool' },
    { key: 'chapter_10_completed', label: 'Completó los 10 capítulos', kind: 'bool' },
    { key: 'legend_shirt_claimed', label: 'Ha reclamado la camiseta de Leyenda', kind: 'bool' },
    { key: 'real_account', label: 'Cuenta real (no prueba, sistema ni admin)', kind: 'bool' },
    { key: 'no_open_after_first_day', label: 'No abre la app pasadas 24 h del registro', kind: 'bool' },
    { key: 'capture_count', label: 'Número de capturas', kind: 'num' },
    { key: 'ambassador_invites', label: 'Amigos unidos con su invitación', kind: 'num' },
    { key: 'zone_capture_count', label: 'Capturas en su zona principal', kind: 'num' },
    { key: 'profile_steps_left', label: 'Pasos de perfil que le faltan', kind: 'num' },
    { key: 'wallet_euros', label: 'Saldo del monedero (€)', kind: 'num' },
    { key: 'following_count', label: 'Número de seguidos', kind: 'num' },
    { key: 'days_since_signup', label: 'Días desde el registro', kind: 'num' },
    { key: 'days_since_last_seen', label: 'Días desde la última entrada', kind: 'num' },
    { key: 'days_since_last_capture', label: 'Días desde la última captura', kind: 'num' },
    { key: 'days_since_last_email_open', label: 'Días desde que abrió un correo', kind: 'num' },
    { key: 'experience_level', label: 'Nivel de experiencia', kind: 'text' },
    { key: 'water_type', label: 'Tipo de agua', kind: 'text' },
    { key: 'billing_interval', label: 'Intervalo de facturación Pro', kind: 'text' },
] as const;

export const BILLING_INTERVAL_OPTIONS = [
    { key: 'month', label: 'Mensual (month)' },
    { key: 'year', label: 'Anual (year)' },
    { key: 'annual', label: 'Anual App Store (annual)' },
] as const;

export const BOOLEAN_SIGNALS = [
    { key: 'has_email', label: 'Tiene email válido' },
    { key: 'has_capture', label: 'Tiene captura' },
    { key: 'has_zone', label: 'Tiene zona (lat/lng)' },
    { key: 'is_pro', label: 'Es Pro (cualquier alta activa)' },
    { key: 'paid_pro', label: 'Pro de pago' },
    { key: 'in_club', label: 'Está en un club' },
    { key: 'in_trial', label: 'Prueba Pro activa' },
    { key: 'in_real_club', label: 'Está en un club no oficial' },
] as const;

export const NUMERIC_SIGNALS = [
    { key: 'capture_count', label: 'Nº de capturas' },
    { key: 'following_count', label: 'Nº de seguidos' },
    { key: 'ambassador_invites', label: 'Amigos unidos con su invitación' },
] as const;

export const EXPERIENCE_OPTIONS = [
    { key: 'principiante', label: 'Principiante' },
    { key: 'intermedio', label: 'Intermedio' },
    { key: 'experto', label: 'Experto' },
] as const;

export const WATER_OPTIONS = [
    { key: 'dulce', label: 'Dulce' },
    { key: 'salada', label: 'Salada' },
    { key: 'ambas', label: 'Ambas' },
] as const;

export const ENROLL_EVENTS = [
    { key: 'first_capture', label: 'Primera captura (no borrador)' },
    { key: 'pro_started', label: 'Alta Pro / trial (suscripción activa nueva)' },
    { key: 'club_joined', label: 'Entra en un club' },
] as const;

export const ACTIVATION_STEPS = [
    {
        id: 'a0',
        title: 'Bienvenida',
        when: 'Retirado. Salía unas 2 horas después del registro',
        from: 'Alberto · hola@aipeces.com',
        prefix: 'activacion_a0',
    },
    {
        id: 'a1',
        title: 'Día 2',
        when: 'Retirado. Salía si a las 48 horas no había ninguna captura',
        from: 'Alberto · hola@aipeces.com',
        prefix: 'activacion_a1',
    },
    {
        id: 'a2',
        title: 'Día 4',
        when: 'Retirado. Salía hacia el día 4, según la zona',
        from: 'Alberto · hola@aipeces.com',
        prefix: 'activacion_a2',
    },
    {
        id: 'a3',
        title: 'Día 7',
        when: 'Retirado. Salía hacia el día 7, por captura o seguidos',
        from: 'Alberto · hola@aipeces.com',
        prefix: 'activacion_a3',
    },
] as const;

export const ACTIVATION_SEND_LABELS: Record<string, string> = {
    activacion_a0: 'Cuerpo y botón',
    activacion_a1: 'Sin captura',
    activacion_a2_sin_zona: 'Sin zona',
    activacion_a2_zona_pct: 'Con zona, en porcentaje',
    activacion_a2_zona_abs: 'Con zona, en número',
    activacion_a2_fallback_atlas: 'Si no hay datos, Atlas',
    activacion_a2_fallback_academia: 'Si no hay datos, Academia',
    activacion_a3_captura: 'Si ya hay captura',
    activacion_a3_seguidos: 'Si hay seguidos',
};

export const TEMPLATE_CHANNELS = [
    { key: 'email', label: 'Email' },
    { key: 'subject', label: 'Asunto (variante)' },
    { key: 'fragment', label: 'Fragmento' },
] as const;

export const RESOLVER_OPTIONS = [
    { key: 'template', label: 'Plantilla (copy fijo)' },
    { key: 'activation_a0', label: 'Activación A0 (nivel × agua)' },
    { key: 'activation_a1', label: 'Activación A1 (primera captura)' },
    { key: 'activation_a2', label: 'Activación A2 (zona + veracidad)' },
    { key: 'activation_a3', label: 'Activación A3 (captura / seguidos)' },
] as const;

export const TOPIC_OPTIONS = [
    'cuenta', 'zona', 'social', 'logros', 'academia', 'pro', 'tienda',
] as const;

export const CLASS_OPTIONS = [
    { key: 'activacion', label: 'Activación' },
    { key: 'valor', label: 'Valor / editorial' },
    { key: 'relacional', label: 'Relacional' },
    { key: 'promocional', label: 'Promocional' },
    { key: 'transaccional', label: 'Transaccional' },
] as const;

export const EVENT_DRIVEN_FLOWS = [
    { type: 'like', class: 'relacional', topic: 'social', note: 'Trigger SQL. Cap 2/día.' },
    { type: 'comment / reply', class: 'relacional', topic: 'social', note: 'Trigger SQL.' },
    { type: 'follow', class: 'relacional', topic: 'social', note: 'Consolidado 5 min.' },
    { type: 'curated_capture', class: 'valor', topic: 'social', note: 'Cron diario. 1 push valor/día.' },
    { type: 'weekly_top_14', class: 'valor', topic: 'logros', note: 'Lunes. Pasa por canSend.' },
    { type: 'monthly_summary', class: 'valor', topic: 'logros', note: 'Día 1.' },
    { type: 'pro_coupon_expiring', class: 'transaccional', topic: 'pro', note: '48/72 h antes.' },
    { type: 'fishing_club_rank_up', class: 'valor', topic: 'logros', note: 'No consume tope valor/día.' },
] as const;
